/**
 * ⟦C50 · A-169 §2⟧ Les patterns du Montage pré-calculés sur l'audio (`content/montage-patterns.json`), côté
 * client, **pour le bac à sable seulement**.
 *
 * En compte, le serveur tire le pattern et le client ne reçoit que les carrés (`depuisServeur`) : ce module
 * n'est jamais chargé. En bac à sable (aucun serveur), le client tire dans le MÊME fichier, avec la MÊME
 * fonction de choix (`choisirPatternMontage`, `@maxime/shared`) : il ne calcule aucun carré, il en lit.
 *
 * Importé **à la demande** (`import()` : Vite en fait un fragment à part) : 600 Ko de JSON que ni le jeu en
 * compte ni les autres écrans n'ont à porter. Validé par le schéma que le serveur applique au boot : un
 * fichier qui ne tient pas lève ici, et l'écran le dit au lieu de jouer sur du faux.
 */

import { MontagePatternsFile } from "@maxime/shared";

let promesse: Promise<MontagePatternsFile> | null = null;

export function chargerPatternsMontage(): Promise<MontagePatternsFile> {
  promesse ??= import("@content/montage-patterns.json")
    .then((m: { default: unknown }) => MontagePatternsFile.parse(m.default))
    .catch((e: unknown) => {
      promesse = null; // un échec ne se met pas en cache : l'écran peut réessayer
      throw e;
    });
  return promesse;
}
